import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { WidgetHealthIssue } from '@/types.ts';

type ChartHealthIssuesProps = {
  isLoading: boolean;
  isError: boolean;
  /** The request is being retried because the API is rate limiting (HTTP 429). */
  isRateLimited?: boolean;
  fetchFailedMessage?: string;
};

export const useChartHealthIssues = ({
  isLoading,
  isError,
  isRateLimited = false,
  fetchFailedMessage,
}: ChartHealthIssuesProps): WidgetHealthIssue[] => {
  const { t } = useTranslation(['common', 'chartConfig']);
  return useMemo(() => {
    // Rate limiting outranks loading: the widget is stuck on the spinner precisely because of it.
    if (isRateLimited) return [{ severity: 'warning', message: t('dataDelayedHighTraffic') }];
    if (isLoading) return [{ severity: 'warning', message: t('loading') }];
    if (isError) {
      return [
        {
          severity: 'error',
          message: fetchFailedMessage ? fetchFailedMessage : t('chartConfig:dataLoadFailed'),
        },
      ];
    }
    return [];
  }, [isRateLimited, isLoading, isError, fetchFailedMessage, t]);
};
